document.addEventListener("DOMContentLoaded", () => {
    const guide = document.querySelector(".Guide");
    if (!guide) return;

    const guideTitles = document.querySelectorAll(".Guide-title");
    const guideTitlesContainer = document.querySelector(".Guide-titles");
    const letters = document.querySelectorAll(".Guide-letter");
    const filterButtons = document.querySelectorAll(".js-filterButton");
    const backArrows = document.querySelectorAll(".Guide-backArrow");

    const breakpoint = 768;
    let manuallySelectedLetter = null;

    const updateLetter = (letter) => {
        letters.forEach(el => el.classList.toggle("--active", el.textContent.trim() === letter));
    };

    const adjustPaddingBottom = () => {
        if (window.innerWidth <= breakpoint || !guideTitles.length) {
            guideTitlesContainer.style.paddingBottom = "";
            return;
        }

        const lastGuideTitle = guideTitles[guideTitles.length - 1];
        if (!lastGuideTitle) return;

        const guideTitleHeight = lastGuideTitle.getBoundingClientRect().height;
        const numOfLastLetters = [...guideTitles].filter(title => title.textContent.trim()[0] === lastGuideTitle.textContent.trim()[0]).length;

        guideTitlesContainer.style.paddingBottom = `${guideTitleHeight * (14.5 - numOfLastLetters)}px`;
    };

    // Optimize Resize Event Listener
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            adjustPaddingBottom();
            handleHashChange();
        }, 150);
    });

    adjustPaddingBottom();

    // **Intersection Observer**
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !manuallySelectedLetter) {
                updateLetter(entry.target.textContent.trim()[0]);
            }
        });
    });

    guideTitles.forEach(title => observer.observe(title));

    guideTitlesContainer?.addEventListener("click", (e) => {
        if (!e.target.classList.contains("Guide-title")) return;
        guideTitles.forEach(title => title.classList.remove("--active"));
        e.target.classList.add("--active");
        showGuideContent(e.target, window.innerWidth <= breakpoint);
    });

    letters.forEach(letterEl => {
        letterEl.addEventListener("click", function () {
            manuallySelectedLetter = this.textContent.trim();
            updateLetter(manuallySelectedLetter);
            setTimeout(() => (manuallySelectedLetter = null), 3000);
        });
    });

    filterButtons.forEach(button => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            const isActive = button.classList.contains("--active");

            filterButtons.forEach(btn => btn.classList.remove("--active"));
            guideTitles.forEach(title => (title.style.display = "none"));

            if (!isActive) {
                button.classList.add("--active");
                guideTitles.forEach(title => {
                    if (title.dataset.group === button.dataset.group) {
                        title.style.display = "block";
                    }
                });
            } else {
                guideTitles.forEach(title => (title.style.display = "block"));
            }
        });
    });

    const showGuideContent = (element, isMobile = false) => {
        if (!element.classList.contains("Guide-title")) return;

        const dataId = element.dataset.id;
        if (!dataId) return;

        const prevActive = document.querySelector(".Guide-content.--active");
        if (prevActive?.dataset.id === dataId) return;

        prevActive?.classList.remove("--active");

        // Remove hash from URL
        history.replaceState(null, document.title, location.href.split("#")[0]);

        const contentWrapper = document.querySelector(`.Guide-content[data-id='${dataId}']`);
        if (!contentWrapper) return;

        contentWrapper.classList.add("--active");
        document.body.classList.add("no-scroll");

        contentWrapper.querySelectorAll(".js-guideImages").forEach(img => {
            if (img.dataset.src) img.src = img.dataset.src;
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        });

        // **Update active letter when clicking a title**
        updateLetter(element.textContent.trim()[0]);

        if (isMobile) {
            contentWrapper.removeEventListener("click", removeActiveGuideContent);
            contentWrapper.addEventListener("click", removeActiveGuideContent);
        }

        if (element.dataset.slug) {
            history.replaceState(null, "", element.dataset.slug);
        }
    };

    const removeActiveGuideContent = (event) => {
        if (!event.target.classList.contains("Guide-backArrow")) return; // ⬅ **Only close when clicking backArrow**
        event.stopPropagation();

        const contentWrapper = event.target.closest(".Guide-content");
        if (!contentWrapper) return;

        contentWrapper.classList.add("--closing");
        contentWrapper.classList.remove("--active");

        document.body.classList.remove("no-scroll");

        // Delay height reset after transition (matching CSS duration)
        setTimeout(() => {
            contentWrapper.classList.remove("--closing");
        }, 350);

        // Remove hash immediately
        history.replaceState(null, document.title, location.href.split("#")[0]);
    };

    // **Close Guide-content on Back Arrow Click**
    backArrows.forEach(arrow => {
        arrow.addEventListener("click", removeActiveGuideContent);
    });

    const handleHashChange = () => {
        if (!window.location.hash) return;

        guideTitles.forEach(guideTitle => {
            if (guideTitle.dataset.slug === window.location.hash) {
                scrollToElement(guideTitle, "3.5rem", "6rem");
                showGuideContent(guideTitle, window.innerWidth <= breakpoint);
                guideTitle.classList.add("--active");
            }
        });
    };

    window.addEventListener("hashchange", handleHashChange);

    const InitAlphabet = () => {
        letters.forEach(letter => {
            letter.addEventListener("click", () => {
                const letterValue = letter.textContent.trim().toLowerCase();
                for (let title of guideTitles) {
                    if (title.textContent.trim().toLowerCase().startsWith(letterValue)) {
                        scrollToElement(title, "3.5rem", "6rem");
                        break;
                    }
                }
            });
        });
    };

    const scrollToElement = (element, desktopMargin, mobileMargin) => {
        element.style.scrollMarginTop = window.innerWidth <= 480 ? mobileMargin : desktopMargin;
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    handleHashChange();
    InitAlphabet();
});
